import React from 'react';
import { ITableDataSource } from 'models/table';
import { Table } from 'components/molecules/Table';
import { documentsTableColumns } from './helpers';

const documentsData: ITableDataSource[] = [
  {
    id: '94672ffc-8251-4fd4-a38c-21b47735f9e0',
    name: 'Photo Identity',
    filenames: '',
    date: '2025-05-06',
    completed: true,
  },
  {
    id: '94672ffc-8251-4fd4-a38c-21b47735f9ee',
    name: 'Medical Information Proforma',
    filenames: '',
    date: '2025-05-06',
    completed: true,
  },
  {
    id: '94672ffc-8251-4fd4-a38c-21b47735f9ee',
    name: 'Criminal Record Check Certificate',
    filenames: '',
    date: '',
    completed: false,
  },
  {
    id: '94672ffc-8251-4fd4-a38c-21b47735f9ee',
    name: 'Medical Fitness Document',
    filenames: '',
    date: '',
    completed: false,
  },
  {
    id: '94672ffc-8251-4fd4-a38c-21b47735f9ee',
    name: 'Anti-doping and Alcohol Test',
    filenames: '',
    date: '',
    completed: false,
  },
  {
    id: '94672ffc-8251-4fd4-a38c-21b47735f9ee',
    name: 'Competency Certificate',
    filenames: '',
    date: '2025-05-06',
    completed: true,
  },
  {
    id: '94672ffc-8251-4fd4-a38c-21b47735f9ee',
    name: 'Ballistic and Biometric Tests',
    filenames: '',
    date: '',
    completed: false,
  },
  {
    id: '94672ffc-8251-4fd4-a38c-21b47735f9ee',
    name: 'Constance of acquisition of a weapon',
    filenames: '',
    date: '',
    completed: false,
  },
  {
    id: '94672ffc-8251-4fd4-a38c-21b47735f9ee',
    name: 'Tax Payments for Bearing and Bearing',
    filenames: '',
    date: '',
    completed: false,
  },
];

const DocumentsStep = () => (
  <Table columns={documentsTableColumns()} dataSource={documentsData} />
);

export default DocumentsStep;
